import { render, staticRenderFns } from "./receiptTempalteShopList.vue?vue&type=template&id=0ab861cb&scoped=true&"
import script from "./receiptTempalteShopList.vue?vue&type=script&lang=js&"
export * from "./receiptTempalteShopList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab861cb",
  null
  
)

component.options.__file = "receiptTempalteShopList.vue"
export default component.exports